import type { SVGProps } from 'react';
export const IconKitProfile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx={18}
      cy={11}
      r={5}
      stroke="currentColor"
    />
    <path
      d="M6 29C7.04322 23.3108 12.019 19 18 19C23.981 19 28.9568 23.3108 30 29"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);
